export default "__VITE_ASSET__XmNBF45K__"